const ProductNameDisplay = ({ name }) => (
  <div>
    <label className="block text-sm font-medium font-inter text-gray-600 mb-2">Product Name</label>
    <input
      value={name}
      readOnly
      className="bg-neutral-200-100 border-b border-gray-300 w-full h-[45px] rounded-[3.39px] px-4 text-gray-600 cursor-not-allowed"
    />
  </div>
)

export default ProductNameDisplay
